module.exports = __webpack_public_path__ + "static/media/PM63.98d23431.png";